import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { COMPONENT_RESIZE } from '../../../../common/GoldenLayoutWrapper';
import Loading from '../../../../common/loading/Loading';
import { getNumberColumn } from '../../helper';
import { REDUCER_NAME } from '../../reducer';
import FinancialStatementTable from '../financial-statement-table/FinancialStatementTable';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../app/commonReducer';
import NoData from '../NoData';

class FinancialStatementLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: null,
    };
    this.rootRef = React.createRef();
  }

  componentDidMount() {
    const { fetchData, organCode, componentId, organizations } = this.props;
    if (organizations.length) {
      fetchData(
        {
          OrganCode: organCode,
        },
        componentId,
      );
    }

    this.calcWidth();
    window.addEventListener(COMPONENT_RESIZE, this.calcWidth);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { organCode, fetchData, componentId, organizations } = this.props;
    const isChangeOrganization =
      organizations.length && !prevProps.organizations.length;
    if (organCode !== prevProps.organCode || isChangeOrganization) {
      fetchData(
        {
          OrganCode: organCode,
        },
        componentId,
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.calcWidth);
  }

  calcWidth = () => {
    setTimeout(() => {
      if (!this.rootRef.current) {
        return;
      }
      const width = this.rootRef.current.closest('.lm_content').clientWidth;
      if (width > 0) {
        this.setState({
          width: width - 40, //Minus padding
        });
      }
    }, 0);
  };

  onStartIndexChange = startIndex => {
    this.setState({
      startIndex,
    });
  };

  render() {
    const { width } = this.state;
    const {
      isLoading,
      skip,
      ids,
      fields,
      timeKey,
      dataByIds,
      children,
      getDataFromRedux,
      isAllParent,
      rawData,
    } = this.props;
    const isNoData = rawData && rawData[timeKey] && !rawData[timeKey].length;
    if (isNoData) {
      return (
        <div ref={this.rootRef}>
          <NoData />
        </div>
      );
    }
    return (
      <div
        ref={this.rootRef}
        className="position-relative d-flex flex-column flex-fill"
      >
        {width && (
          <div
            className={`d-flex flex-column flex-fill ${
              isLoading ? 'fs-blur' : ''
            }`}
          >
            {children &&
              typeof children === 'function' &&
              children(skip, getNumberColumn(width))}
            <div className="d-flex flex-fill financial-statement-table">
              <FinancialStatementTable
                numberColumn={getNumberColumn(width)}
                isAllParent={isAllParent}
                ids={ids}
                getDataFromRedux={getDataFromRedux}
                fields={fields}
                timeKey={timeKey}
                dataByIds={dataByIds}
                onStartIndexChange={this.onStartIndexChange}
              />
            </div>
          </div>
        )}
        {isLoading && <Loading />}
      </div>
    );
  }
}

FinancialStatementLayout.propTypes = {
  fetchData: PropTypes.func.isRequired,
  ids: PropTypes.array.isRequired,
  organCode: PropTypes.string,
  timeKey: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  i18nPrefix: PropTypes.string,
  getDataFromRedux: PropTypes.func.isRequired,
  componentId: PropTypes.number.isRequired,
};

FinancialStatementLayout.defaultProps = {};

const mapStateToProps = (state, { componentId }) => ({
  organizations: state[COMMON_REDUCER_NAME].listOrganizationSearch,
  skip: state[REDUCER_NAME][componentId].skip,
});

export default connect(mapStateToProps)(FinancialStatementLayout);
